import React from 'react';
import './footer.sass';
import '../const';
import { footerConst } from '../const';

export const FooterMap = () => {
    return(
        <>
            {footerConst.map((item: {footerImg: string, footerSite: string, altFooter: string}, index: number) => {
                return(
                    <a key={index} href={item.footerSite} className='footerImg'>
                    <img src={item.footerImg} alt={item.altFooter}/>
                  </a>  
                )})}     
        </>
    )
}